import { useTheme } from '@mui/system';
import { Box } from '@mui/material';

export const WaitlistNote = () => {
  const theme = useTheme();

  return (
    <Box sx={{ my: 4, p: 2, backgroundColor: theme.palette.background.sticky, display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
      <strong>We're starting a waitlist, and we often have cancellations prior to the Ball, so please go ahead and sign up for the waitlist here.</strong>
    </Box>
  );
};
